var _rect, _rect2, _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Request"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -311,
    y: -237,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Comment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2892_239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H15.9994V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2892_239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98328 16.0001C6.84583 16.0001 5.70095 15.7597 4.62975 15.2639C4.31413 15.1374 4.0186 15.0183 3.80645 15.0183C3.56228 15.0198 3.234 15.1329 2.91689 15.2423C2.26628 15.4657 1.45637 15.7441 0.857131 15.1471C0.260121 14.5493 0.53555 13.7416 0.757381 13.0918C0.866808 12.7717 0.979213 12.4412 0.979213 12.191C0.979213 11.9856 0.880207 11.7236 0.728349 11.3462C-0.665913 8.33505 -0.0212622 4.7061 2.3437 2.34263C3.85334 0.83224 5.86248 0 8.00115 0C10.1398 0 12.1497 0.831495 13.6593 2.34188C16.7799 5.46241 16.7799 10.5392 13.6593 13.6598C12.1296 15.1902 10.0698 16.0001 7.98328 16.0001V16.0001Z",
    fill: "white",
    fillOpacity: 0.3
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9427 9.0513C10.5318 9.0513 10.1953 8.71855 10.1953 8.3069C10.1953 7.89525 10.5251 7.5625 10.936 7.5625H10.9427C11.3536 7.5625 11.6871 7.89525 11.6871 8.3069C11.6871 8.71855 11.3536 9.0513 10.9427 9.0513",
    fill: "#021239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95832 9.0513C7.54741 9.0513 7.21094 8.71855 7.21094 8.3069C7.21094 7.89525 7.53996 7.5625 7.95162 7.5625H7.95832C8.36923 7.5625 8.70272 7.89525 8.70272 8.3069C8.70272 8.71855 8.36923 9.0513 7.95832 9.0513",
    fill: "#021239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97394 9.0513C4.56303 9.0513 4.22656 8.71855 4.22656 8.3069C4.22656 7.89525 4.55633 7.5625 4.96724 7.5625H4.97394C5.38485 7.5625 5.71834 7.89525 5.71834 8.3069C5.71834 8.71855 5.38485 9.0513 4.97394 9.0513",
    fill: "#021239"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.b96842cf67bdc8305a590f12a40f8ec0.svg";
export { ForwardRef as ReactComponent };